import { render, staticRenderFns } from "./TrainingVideoLink.vue?vue&type=template&id=5e23367b"
import script from "./TrainingVideoLink.vue?vue&type=script&lang=ts"
export * from "./TrainingVideoLink.vue?vue&type=script&lang=ts"
import style0 from "./TrainingVideoLink.vue?vue&type=style&index=0&id=5e23367b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports